<div class="fill-height p-2 d-flex justify-content-center px-lg-4 px-xl-5">

  <div *ngIf="isLoading" class="d-flex h-100 align-items-center justify-content-center">
    <mat-spinner class="zx-small-icon-size"></mat-spinner>
  </div>

  <div *ngIf="!isLoading" class="w-100 flex-grow-1 d-flex flex-column">

    <article class="d-flex align-items-center gap-2 w-100 p-3 c-pointer" (click)="goToNewOrder()">
      <img [src]="'assets/images/plotter-icon.svg'" alt="choosen printing system icon" class="zx-small-icon-size">
      <img *ngIf="branch" [src]="'assets/images/branches/' + branch.serial_name+ '.png'"
        alt="choosen printing system icon" class="zx-small-icon-size c-pointer">
      <span *ngIf="branch" class="zx-text-small">
        {{ "choose-branch.naming.plotter." + branch.serial_name | translate }}
      </span>
      <span class="spacer d-md-none"></span>
    </article>

    <h6 class="mb-3 zx-text-small fw-bold zx-text-sm-medium">
      {{ "order-complited.printed.view-que.short" | translate }}<span *ngIf="isEditMode" class="text-green"> - {{ "queue.edit-mode" | translate }}</span>
    </h6>

    <!-- QUEUE AREA ========= QUEUE AREA ========= QUEUE AREA ========= QUEUE AREA ========= QUEUE AREA ========= QUEUE AREA ========= QUEUE AREA -->
    <article class="d-flex flex-column align-items-center flex-grow-1 w-100">

      <!-- == QUEUE header == -->
      <div class="zx-que-que-header-con zx-que-min-h-order d-flex row">

        <!-- place -->
        <div class="col-4 col-md-3 p-1 p-lg-3 h-100 d-flex align-items-center justify-content-center">
          <b class="zx-text-tiny zx-text-sm-small text-white">
            {{ "s-screen.plotter-que.title.place" | translate }}
          </b>
        </div>
        <!-- // place -->

        <!-- username -->
        <div class="col-4 col-md-3 p-1 p-lg-3 h-100 d-flex align-items-center justify-content-center">
          <b class="zx-text-tiny zx-text-sm-small text-white">
            {{ "s-screen.plotter-que.title.username" | translate }}
          </b>
        </div>
        <!-- // username -->

        <!-- empty -->
        <div class="col-3 d-none d-md-flex p-1 p-lg-3 h-100 "></div>
        <!-- // empty -->

        <!-- status -->
        <div class="col-4 col-md-3 p-1 p-lg-3 h-100 d-flex align-items-center justify-content-center">
          <b class="zx-text-tiny zx-text-sm-small text-white">
            {{ "s-screen.plotter-que.title.status" | translate }}
          </b>
        </div>
        <!-- status -->

      </div>
      <!-- // == QUEUE header == -->

      <!-- == QUEUE content == -->
      <div class="d-flex w-100 flex-grow-1 flex-shrink-1 position-relative">
        <div class="d-flex w-100 flex-column h-100 overflow-auto position-absolute" style="max-height: 100%;">

          <!-- ----- printerQueue orders -----  *ngFor="let order of branch.printers[0].printerQueue" -->
          <section *ngIf="branch?.printers && branch.printers?.length > 0 &&
            branch.printers[0]?.printerQueue && branch.printers[0]?.printerQueue?.length > 0"
            class="w-100 d-flex flex-column p-0 m-0">
            <ng-container *ngFor="let order of branch.printers[0]?.printerQueue; let i = index">
              <!-- dummy: paper replacement pill (managers only, when order has isNotEnoughPaper) -->
              <div *ngIf="shouldShowPaperReplacementDummy(order, i, true)"
                class="w-100 d-flex align-items-center justify-content-center py-1 zx-que-order-dummy">
                <span class="zx-text-small fw-bold text-danger">
                  {{ (order?.isNotEnoughPaper ? 'queue.paper-replacement' : 'queue.queue-will-stop') | translate }}
                </span>
              </div>
              <!-- real order -->
            <div
              class="zx-que-order zx-que-min-h-order w-100 d-flex row p-0 m-0 position-relative" [class.zx-que-order-printing]="i === 0">

              <!-- place -->
              <div class="col-4 col-md-3 p-0 h-100 d-flex align-items-center justify-content-center">
                <!-- 1st order -->
                <div *ngIf="i === 0" class="d-flex flex-column align-items-center gap-1">
                  <b class="zx-text-small zx-text-sm-medium text-green">
                    {{ "s-screen.plotter-que.title.printing" | translate }}
                  </b>
                  <div class="d-flex flex-column align-items-center justify-content-center gap-1"
                    *ngIf="(isSU || isManiger() || isSt()) && isManigerMode">
                    <b *ngFor="let paper of getOrderPapers(order); trackBy: trackByPaperSerialName"
                      class="zx-text-tiny-tiny zx-text-sm-tiny zx-text-pink d-flex align-items-center gap-1">
                      <span class="d-inline-flex" matTooltip="{{ 'queue.order-sent-to-printer-tooltip' | translate }}" matTooltipPosition="above"><mat-icon class="zx-queue-print-icon">print</mat-icon></span>
                      {{ "paper-type.name-short." + paper.paperSerialName | translate }}: {{
                      roundDownTowDecimal(paper.length) }} {{ "su-management.branches_m" | translate }}
                    </b>
                  </div>
                </div>
                <!-- // 1st order -->
                <!-- 2nd + orders -->
                <div *ngIf="i > 0" class="d-flex flex-column align-items-center gap-1">
                  <span class="zx-text-small d-flex align-items-center">
                    <span>{{ i + 1 }}</span>
                  </span>
                  <b *ngIf="isSU || isManiger() || isSt()" class="zx-text-tiny-tiny zx-text-sm-tiny text-green">
                    {{ "su-management.received-in-printer" | translate }}
                  </b>
                  <div class="d-flex flex-column align-items-center justify-content-center gap-1"
                    *ngIf="(isSU || isManiger() || isSt()) && isManigerMode">
                    <b *ngFor="let paper of getOrderPapers(order); trackBy: trackByPaperSerialName"
                      class="zx-text-tiny-tiny zx-text-sm-tiny zx-text-pink d-flex align-items-center gap-1">
                      <span class="d-inline-flex" matTooltip="{{ 'queue.order-sent-to-printer-tooltip' | translate }}" matTooltipPosition="above"><mat-icon class="zx-queue-print-icon">print</mat-icon></span>
                      {{ "paper-type.name-short." + paper.paperSerialName | translate }}: {{
                      roundDownTowDecimal(paper.length) }} {{ "su-management.branches_m" | translate }}
                    </b>
                  </div>
                </div>
                <!-- // 2nd + orders -->
              </div>
              <!-- // place -->

              <!-- username -->
              <div class="col-4 col-md-3 p-0 h-100 d-flex align-items-center justify-content-center"
                [class.c-pointer]="isSU" (click)="showUserManigment(order)">
                <span *ngIf="order.user" class="zx-text-small zx-text-sm-medium" [class.text-green]="i === 0"
                  [class.fw-bold]="i === 0">
                  <span>
                    {{ order.user | slice:0:9 }}
                  </span>
                  <span *ngIf="order.user?.length > 9">
                    ...
                  </span>
                </span>
              </div>
              <!-- // username -->

              <!-- empty -->
              <div class="col-3 d-none d-md-flex p-0 h-100"></div>
              <!-- // empty -->

              <!-- status -->
              <div class="col-4 col-md-3 p-0 h-100 d-flex align-items-center justify-content-center">
                <!-- 1st order -->
                <div *ngIf="i === 0" class="d-flex align-items-center gap-2">
                  <span class="d-none d-lg-flex zx-text-medium text-green">
                    {{ "s-screen.plotter-que.title.printing" | translate }}
                  </span>
                  <span
                    class="zx-text-small d-flex flex-row-reverse align-items-center px-2 py-1 rounded-pill zx-bg-gray-v-light-opacity">
                    <span>
                      {{ order.currentImage }}
                    </span>
                    <span>/</span>
                    <span>
                      {{ order.totalOrderLength }}
                    </span>
                  </span>
                </div>
                <!-- // 1st order -->
                <!-- 2nd + orders -->
                <div *ngIf="i > 0" class="d-flex">
                  <span class="zx-text-small">
                    <span>
                      {{ getOrderTimeEstimation(branch, order, i, true) }}
                    </span>
                    <span>
                      {{ "s-screen.minutes.short" | translate }}
                    </span>
                  </span>
                </div>
                <!-- // 2nd + orders -->

                <!-- SU ACTIONS PRINTING QUEUE ==== ==== ==== ====  -->
                <button *ngIf="isSU || isManiger() || isSt()" mat-icon-button color="secondary"
                  [attr.data-order-id-pq]="order._id" [attr.data-order-id-pq]="order._id"
                  class="rounded-pill zx-text-tiny small-btn p-0 mx-1 mx-md-4" [matMenuTriggerFor]="cancelOrderManuPQ"
                  (menuOpened)="openMenuOrderIdPQ = order._id" (menuClosed)="openMenuOrderIdPQ = null">
                  <img class="zx-small-icon-size svg c-pointer" src="assets/images/three-dots-icon.svg"
                    alt="Image Options">
                </button>
                <mat-menu #cancelOrderManuPQ="matMenu">
                  <button *ngIf="isSU" class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL"
                    mat-menu-item (click)="cancelOrder(order, 'CANCELLED')">
                    <div class="d-flex gap-1 px-2 px-lg-3">
                      <mat-icon class="text-red zx-text-medium zx-text-sm-big pt-1 m-0">cancel</mat-icon>
                      <b class="text-red zx-text-small m-0" [class.zx-text-white]="isDarkMode">
                        {{ 'su-management.cancel-order.CANCELLED' | translate }}
                      </b>
                    </div>
                  </button>
                  <button *ngIf="getOrderPhone(order)" class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL" mat-menu-item
                    (click)="copyPhone(order)">
                    <div class="d-flex gap-1 px-2 px-lg-3">
                      <mat-icon class="text-green zx-text-medium zx-text-sm-big pt-1 m-0">content_copy</mat-icon>
                      <b class="text-green zx-text-small m-0" [class.zx-text-white]="isDarkMode">
                        {{ 'su-management.copy-phone' | translate }}
                      </b>
                    </div>
                  </button>
                  <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL" mat-menu-item
                    (click)="copyOrderDetails(order)">
                    <div class="d-flex gap-1 px-2 px-lg-3">
                      <mat-icon class="text-green zx-text-medium zx-text-sm-big pt-1 m-0">content_copy</mat-icon>
                      <b class="text-green zx-text-small m-0" [class.zx-text-white]="isDarkMode">
                        {{ 'su-management.copy-order-details' | translate }}
                      </b>
                    </div>
                  </button>
                </mat-menu>
                <!-- // SU ACTIONS PRINTING QUEUE ==== ==== ==== ====  -->
              </div>
              <!-- status -->

            </div>
            </ng-container>
          </section>
          <!-- // ----- printerQueue orders ----- -->

          <!-- ----- queue orders ----- -->
          <section
            *ngIf="branch && branch.printers && branch.printers[0]?.queue && branch.printers[0]?.queue?.length > 0"
            class="w-100 d-flex flex-column p-0 m-0">
            <ng-container *ngFor="let order of branch.printers[0]?.queue; let i = index">
              <!-- dummy: paper replacement pill (managers only, when order has isNotEnoughPaper) -->
              <div *ngIf="shouldShowPaperReplacementDummy(order, i, false)"
                class="w-100 d-flex align-items-center justify-content-center py-1 zx-que-order-dummy">
                <span class="zx-text-small fw-bold text-danger">
                  {{ (order?.isNotEnoughPaper ? 'queue.paper-replacement' : 'queue.queue-will-stop') | translate }}
                </span>
              </div>
              <!-- real order -->
            <div
              class="zx-que-order zx-que-min-h-order w-100 d-flex row p-0 m-0 position-relative"
              [class.zx-que-order-odd]="branch.printers[0]?.printerQueue.length % 2 !== 0">

              <!-- edit button - absolute positioned -->
              <button *ngIf="isEditMode && isSU" mat-icon-button color="primary" 
                class="zx-edit-order-btn text-green position-absolute" 
                [class.zx-edit-order-btn-rtl]="isRTL"
                [class.zx-edit-order-btn-ltr]="!isRTL"
                [class.zx-edit-order-btn-selected]="selectedOrderForMove?._id === order._id"
                [class.zx-edit-order-btn-unselected]="selectedOrderForMove && selectedOrderForMove._id !== order._id"
                (click)="selectOrderForMove(order, i)">
                <mat-icon>unfold_more</mat-icon>
              </button>
              <!-- // edit button -->

              <!-- position target button - bottom center -->
              <button *ngIf="isEditMode && isSU && selectedOrderForMove" mat-icon-button 
                class="zx-position-target-btn position-absolute"
                [class.zx-position-target-btn-enabled]="!(i === selectedOrderIndex || i === selectedOrderIndex - 1)"
                [disabled]="i === selectedOrderIndex || i === selectedOrderIndex - 1"
                (click)="moveOrderToPosition(i)">
                <mat-icon>swap_horiz</mat-icon>
              </button>
              <!-- // position target button -->

              <!-- place -->
              <div class="col-4 col-md-3 p-0 h-100 d-flex flex-column align-items-center justify-content-center gap-1">
                <span class="zx-text-small zx-text-sm-medium">
                  {{ i + 1 + (branch.printers[0]?.printerQueue?.length ? branch.printers[0]?.printerQueue?.length : 0)
                  }}
                </span>
                <div class="d-flex flex-column align-items-center justify-content-center gap-1"
                  *ngIf="(isSU || isManiger() || isSt()) && isManigerMode">
                  <b *ngFor="let paper of getOrderPapers(order); trackBy: trackByPaperSerialName" class="zx-text-tiny-tiny zx-text-sm-tiny zx-text-pink">
                    {{ "paper-type.name-short." + paper.paperSerialName | translate }}: {{
                    roundDownTowDecimal(paper.length) }} {{ "su-management.branches_m" | translate }}
                  </b>
                </div>
              </div>
              <!-- // place -->

              <!-- username -->
              <div class="col-4 col-md-3 p-0 h-100 d-flex align-items-center justify-content-center"
                [class.c-pointer]="isSU" (click)="showUserManigment(order)">
                <span *ngIf="order.user" class="zx-text-small zx-text-sm-medium">
                  <span>
                    {{ order.user | slice:0:9 }}
                  </span>
                  <span *ngIf="order.user?.length > 9">
                    ...
                  </span>
                </span>
              </div>
              <!-- // username -->

              <!-- empty -->
              <div class="col-3 d-none d-md-flex p-0 h-100"></div>
              <!-- // empty -->

              <!-- status -->
              <div class="col-4 col-md-3 p-0 h-100 d-flex align-items-center justify-content-center">
                <div class="d-flex flex-column align-items-center">
                  <span
                    *ngIf="!(branch.printers[0]?.printerQueue && branch.printers[0]?.printerQueue?.length > 0) && i === 0"
                    class="zx-text-small zx-text-sm-medium text-center">
                    {{ "s-screen.plotter-que.title.proccessing" | translate }}
                  </span>
                </div>
                <span
                  *ngIf="(branch.printers[0]?.printerQueue && branch.printers[0]?.printerQueue?.length > 0) || i !== 0"
                  class="zx-text-small zx-text-sm-medium">
                  <span>
                    {{ getOrderTimeEstimation(branch, order, i, false) }}
                  </span>
                  <span>
                    {{ "s-screen.minutes.short" | translate }}
                  </span>
                </span>
                <!-- SU ACTIONS QUEUE ==== ==== ==== ====  -->
                <button *ngIf="(isSU || isManiger() || isSt()) && orderIsInQueue(order)" mat-icon-button
                  color="secondary" class="rounded-pill zx-text-tiny small-btn p-0 mx-1 mx-md-4"
                  [matMenuTriggerFor]="cancelOrderManuQ" [attr.data-order-id-q]="order._id"
                  [attr.data-order-id-q]="order._id" (menuOpened)="openMenuOrderIdQ = order._id"
                  (menuClosed)="openMenuOrderIdQ = null">
                  <img class="zx-small-icon-size svg c-pointer" src="assets/images/three-dots-icon.svg"
                    alt="Image Options">
                </button>
                <mat-menu #cancelOrderManuQ="matMenu">
                  <button *ngIf="isSU && i !== 0 && order.status === 'INQUEUE'"
                    class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL" mat-menu-item
                    (click)="PromoteOrderInQueue(order)">
                    <div class="d-flex gap-1 px-2 px-lg-3">
                      <mat-icon class="text-green zx-text-medium zx-text-sm-big pt-1 m-0">arrow_upward</mat-icon>
                      <b class="text-green zx-text-small m-0" [class.zx-text-white]="isDarkMode">
                        {{ 'promote-order.btn' | translate }}
                      </b>
                    </div>
                  </button>
                  <button *ngIf="!order.adminOrder && isSU" class="d-flex align-items-center gap-1 px-2"
                    [class.zx-ltr]="!isRTL" mat-menu-item (click)="cancelOrder(order, 'REFUNDED')">
                    <div class="d-flex gap-1 px-2 px-lg-3">
                      <mat-icon class="text-red zx-text-medium zx-text-sm-big pt-1 m-0">cancel</mat-icon>
                      <b class="text-red zx-text-small m-0" [class.zx-text-white]="isDarkMode">
                        {{ 'su-management.cancel-order.REFUNDED' | translate }}
                      </b>
                    </div>
                  </button>
                  <button *ngIf="!order.adminOrder && isSU" class="d-flex align-items-center gap-1 px-2"
                    [class.zx-ltr]="!isRTL" mat-menu-item (click)="cancelOrder(order, 'REFUNDED_POINTS')">
                    <div class="d-flex gap-1 px-2 px-lg-3">
                      <mat-icon class="text-red zx-text-medium zx-text-sm-big pt-1 m-0">cancel</mat-icon>
                      <b class="text-red zx-text-small m-0" [class.zx-text-white]="isDarkMode">
                        {{ 'su-management.cancel-order.REFUNDED_POINTS' | translate }}
                      </b>
                    </div>
                  </button>
                  <button *ngIf="isSU" class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL"
                    mat-menu-item (click)="cancelOrder(order, 'CANCELLED')">
                    <div class="d-flex gap-1 px-2 px-lg-3">
                      <mat-icon class="text-red zx-text-medium zx-text-sm-big pt-1 m-0">cancel</mat-icon>
                      <b class="text-red zx-text-small m-0" [class.zx-text-white]="isDarkMode">
                        {{ 'su-management.cancel-order.CANCELLED' | translate }}
                      </b>
                    </div>
                  </button>
                  <button *ngIf="getOrderPhone(order)" class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL" mat-menu-item
                    (click)="copyPhone(order)">
                    <div class="d-flex gap-1 px-2 px-lg-3">
                      <mat-icon class="text-green zx-text-medium zx-text-sm-big pt-1 m-0">content_copy</mat-icon>
                      <b class="text-green zx-text-small m-0" [class.zx-text-white]="isDarkMode">
                        {{ 'su-management.copy-phone' | translate }}
                      </b>
                    </div>
                  </button>
                  <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL" mat-menu-item
                    (click)="copyOrderDetails(order)">
                    <div class="d-flex gap-1 px-2 px-lg-3">
                      <mat-icon class="text-green zx-text-medium zx-text-sm-big pt-1 m-0">content_copy</mat-icon>
                      <b class="text-green zx-text-small m-0" [class.zx-text-white]="isDarkMode">
                        {{ 'su-management.copy-order-details' | translate }}
                      </b>
                    </div>
                  </button>
                </mat-menu>
                <!-- // SU ACTIONS QUEUE ==== ==== ==== ====  -->
              </div>
              <!-- status -->

            </div>
            </ng-container>
          </section>
          <!-- // ----- queue orders ----- -->

          <!-- ----- queue is Empty ----- -->
          <section *ngIf="!(branch?.printers[0]?.printerQueue &&
            branch?.printers[0]?.printerQueue?.length > 0) &&
            !(branch?.printers[0]?.queue &&
            branch?.printers[0]?.queue?.length > 0)"
            class="w-100 flex-grow-1 d-flex flex-column justify-content-center">

            <!-- top empty -->
            <div class="w-100 d-flex align-items-center justify-content-center p-2">
              <div
                class="flex-grow-1 d-flex align-items-center justify-content-center px-3 py-2 rounded-pill zx-bg-gray-v-light-opacity">
                <span class="zx-text-small zx-text-sm-medium text-center">
                  {{ "s-screen.plotter-que.empty-title" | translate }}
                </span>
              </div>
            </div>
            <!-- // top empty -->

            <!-- center empty -->
            <div (click)="goToNewOrder()"
              class="w-100 flex-grow-1 d-flex flex-column align-items-center justify-content-center gap-2 p-2">
              <img src="assets/images/que-empty-icon.svg" class="zx-que-empty-icon">
              <b class="zx-que-text-tiny text-green">
                {{ "s-screen.plotter-que.empty-sub" | translate }}
              </b>
            </div>
            <!-- // center empty -->

          </section>

          <!-- for scroller QA -->
          <!-- <section style="width: 100%; min-height: 500px; background-color: blue;"></section> -->

          <div id="endOfContent" style="min-height: 10px;" class="w-100"></div>

          <!-- // ----- queue is Empty ----- -->
        </div>
      </div>
      <!-- // == QUEUE content == -->

      <!-- QUEUE footer -->
      <div *ngIf="branch.printers[0] &&
                  branch.printers[0]?.printerQueue &&
                  branch.printers[0]?.printerQueue?.length > 0 &&
                  branch.printers[0]?.queue &&
                  branch.printers[0]?.queue?.length > 0" class="zx-que-que-footer-con d-flex justify-content-end">
        <div class="d-flex align-items-center px-4 py-1 gap-2">
          <img src="assets/images/printing-que-list-icon.svg" class="zx-que-tiny-icon">
          <span>
            <span>
              {{ getTotalNumOfOrders(branch) }}
            </span>
            <span>
              {{ "s-screen.total-orders" | translate }}
            </span>
          </span>
          <span></span>
          <img src="assets/images/printing-que-time-icon.svg" class="zx-que-tiny-icon">
          <span>
            <span>
              {{ getTotalTimeEstimation(branch) }}
            </span>
            <span>
              {{ "s-screen.total-minutes" | translate }}
            </span>
          </span>
        </div>

      </div>
      <!-- // QUEUE footer -->

    </article>
    <!-- // QUEUE AREA ========= QUEUE AREA ========= QUEUE AREA ========= QUEUE AREA ========= QUEUE AREA ========= QUEUE AREA ========= QUEUE AREA -->

  </div>

</div>

<div class="p-2 pb-lg-3 px-lg-4 px-xl-5 d-flex flex-column">
  <div class="pt-2 d-flex flex-column flex-md-row align-items-center gap-2">
    <button *ngIf="isSU" class="w-100 rounded-pill fw-bold" [class.text-danger]="isEditMode" [class.text-green]="!isEditMode" mat-flat-button type="button" (click)="editPrintingQueue()">
      {{ (isEditMode ? "queue.cancel-edit-mode" : "queue.edit-queue") | translate }}
    </button>
    <div class="w-100 d-flex align-items-center gap-2">
      <button class="w-100 rounded-pill fw-bold text-green" mat-flat-button type="button" (click)="goToNewOrder()">
        {{ "main-nav.new-order" | translate }}
      </button>
      <button *ngIf="isSU || isManiger() || isSt()" type="button" [ngClass]="isRTL ? 'zx-eye-icon-rtl' : 'zx-eye-icon'"
        mat-icon-button (click)="toggleManigerView()" matTooltip="{{ 'su-management.paper-info' | translate }}"
        matTooltipPosition="above">
        <mat-icon class="text-green">{{ isManigerMode ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    </div>
  </div>
  <div *ngIf="getUserNumOfOrders() !== 0" class="pt-2">
    <div class="w-100 d-flex justify-content-center align-items-center">
      <span class="text-center">
        <span>
          {{ "queue.order-will-be-printed-1" | translate }}
        </span>
        <span *ngIf="getUserNumOfOrders() === 1">
          {{ "queue.order-will-be-printed-2-single" | translate }}
        </span>
        <span *ngIf="getUserNumOfOrders() !== 1">
          <span>
            {{ getUserNumOfOrders() }}
          </span>
          <span>
            {{ "queue.order-will-be-printed-2-muli" | translate }}
          </span>
        </span>
        <span>
          {{ getUserNextOrderTimeEstimation() }}
        </span>
        <span>
          {{ "queue.order-will-be-printed-1" | translate }}
        </span>
      </span>
    </div>
  </div>
</div>